<script lang="ts">
	import { m } from '$lib/paraglide/messages';

	const { storesLinks }: { storesLinks: StoreLink[] } = $props();

	let open = $state(false);
</script>

<div>
	<h3 class="mb-2">
		<button
			onclick={() => (open = !open)}
			class="flex size-full cursor-pointer items-center justify-between md:cursor-auto"
		>
			<span class="font-bold">{m.our_stores()}</span>
			<span
				class="{open ? 'icon-[mdi--chevron-up]' : 'icon-[mdi--chevron-down]'} text-2xl md:hidden"
			></span>
		</button>
	</h3>
	<ul class={[{ hidden: open }, 'columns-2 gap-x-4 md:block']}>
		{#each storesLinks as store (store.store_name)}
			<li>
				<a href={store.base_url} target="_blank" rel="noopener noreferrer">{store.store_name}</a>
			</li>
		{/each}
	</ul>
</div>
